import Footer from "../../components/Footer"
import NavbarPrivate from "../../components/navbar/NavbarPrivate"
import NavbarPublic from "../../components/navbar/NavbarPublic"
import useAuth from "../../hooks/useAuth"

const Privacy = () => {
  const { auth } = useAuth()
  return (
    <section className="h-screen flex flex-col">
      {auth ? <NavbarPrivate /> : <NavbarPublic />}
      <div className="mb-auto flex-1 overflow-y-auto">
        <div className="container mx-auto px-5 md:px-16">
          <section id="terms_conditions">
            <h1 className="text-3xl md:text-5xl font-extrabold dark:text-white mt-10">
              Privacy Policy
            </h1>
            <p className="mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300 mt-4">
              This Privacy Policy explains how HackTricks Training collects,
              uses, and protects your personal information when you visit our
              website and subscribe and access our online cybersecurity courses.
            </p>
            <ol className="nested space-y-5 list-inside mb-10">
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Information we collect
                <p className="my-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                  We collect information that you provide to us when you sign up
                  for our courses or contact us through our website. This may
                  include your name, email address, billing and payment
                  information, and other personal information that you
                  voluntarily provide. We may also collect certain technical
                  information about your use of our website, such as your IP
                  address, browser type, and operating system. This information
                  is used to analyze how our website is being used and to
                  improve our services.
                </p>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Use of your information
                <p className="my-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                  We use your personal information to provide you with access to
                  our online cybersecurity courses and to communicate with you
                  about your account and our services. We may also use your
                  information to send you promotional materials or other
                  information that may be of interest to you. We do not share
                  your personal information with third parties except as
                  required by law or as necessary to provide you with our
                  services. We may use third-party service providers to help us
                  operate our website and process payments, but we only share
                  the information necessary to perform these services.
                </p>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Security of your information
                <p className="my-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                  We take reasonable measures to protect your personal
                  information from unauthorized access, use, or disclosure. We
                  use industry-standard security protocols to encrypt sensitive
                  information and store it on secure servers.
                </p>
              </li>

              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Your rights
                <p className="my-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                  You have the right to access and correct the personal
                  information that we hold about you. You may also request that
                  we delete your personal information or restrict how it is
                  used. To exercise these rights, please contact us using the
                  information provided on our website.
                </p>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Changes to this policy
                <p className="my-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                  We may update this Privacy Policy from time to time to reflect
                  changes in our practices or legal requirements. We will notify
                  you of any significant changes by posting a notice on our
                  website or by email.
                </p>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Contact us
                <p className="my-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                  If you have any questions or concerns about our Privacy
                  Policy, please contact us using the information provided on
                  our website.
                </p>
              </li>
            </ol>
            <p className="mb-10 text-lg font-normal text-gray-500 dark:text-neutral-300">
              Last updated: April 25, 2023.
            </p>
          </section>
        </div>
        <Footer />
      </div>
    </section>
  )
}

export default Privacy
